import React from 'react';
import './FilterDetails.css';

function FilterDetails({ count, results }) {
    return (
        <span className="filter-details">{count} {results}</span>
    )
}

export default FilterDetails;
